import { Field, Int, ObjectType } from 'type-graphql'

@ObjectType()
export class OperationResults {
  @Field(() => Boolean)
  acknowledged: boolean

  @Field(() => Int)
  deletedCount: number

  @Field(() => Int)
  matchedCount: number

  @Field(() => Int)
  modifiedCount: number

  @Field(() => [String])
  insertedIds: [string]
  @Field(() => [String])
  upsertedId: [string]

  @Field(() => String)
  ok: string

  @Field(() => String)
  n: string

  @Field(() => String)
  nModified: string
}
